// Generated by `npm run reeffish` (scripts/reefFish.ts): the balance the palenose's stocks open at,
// NOAA's density and mean length of the fish the fishery takes (Nadon 2017), its larvae settling as
// Wren et al.'s model sends them (./exchange.ts, from data/bcodmo-665467/). Do not edit by hand.
// tests/palenose.test.ts holds the balance to a year's step.
import type { FishJanuary, FishSupply } from '../../fish';
import { REEF_FISH_EXCHANGE } from './exchange';

/** The exchange, and the balance's larvae a kilogram of spawners sends, fishing and the rest's spawners. */
export const PALENOSE_SUPPLY: FishSupply = {
  exchange: REEF_FISH_EXCHANGE,
  larvaePerKgDay: 18420.7,
  fishingPerYear: 0.259508,
  restSpawnersKg: 82273.6,
};

/** The balance's first of January (expected values; a world opening rounds the fish): each island's fish by month of age since settling, and the larvae afloat by their days to settle from that day. */
export const PALENOSE_JANUARY: FishJanuary = {
  islands: [
    [45679800, 12200600, 0, 0, 0, 0, 0, 0, 0, 0, 0, 61087.2, 65837.8, 56908.3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9477.46, 11523.3, 11087.7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2972.74, 3614.23, 3477.56, 0, 0, 0, 0, 0, 0, 0, 0, 0, 932.373, 1133.57, 1090.7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 292.43, 355.533, 342.089, 0, 0, 0, 0, 0, 0, 0, 0, 0, 91.7177, 360.698],
    [49906100, 15062300, 0, 0, 0, 0, 0, 0, 0, 0, 0, 89029.7, 97486.8, 76817.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13820.9, 17077.1, 14959.5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4335.13, 5356.17, 4691.93, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1359.67, 1679.91, 1471.58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 426.448, 526.888, 461.547, 0, 0, 0, 0, 0, 0, 0, 0, 0, 133.751, 512.797],
    [31283500, 6307700, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30472.4, 32679.4, 28546.8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4723.91, 5712.11, 5558.7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1481.72, 1791.58, 1743.44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 464.728, 561.911, 546.813, 0, 0, 0, 0, 0, 0, 0, 0, 0, 145.758, 176.238, 171.503, 0, 0, 0, 0, 0, 0, 0, 0, 0, 45.7154, 179.795],
    [8455990, 874429, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3780.9, 4208.6, 3823.2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 584.619, 732.395, 743.326, 0, 0, 0, 0, 0, 0, 0, 0, 0, 183.374, 229.712, 233.138, 0, 0, 0, 0, 0, 0, 0, 0, 0, 57.5135, 72.0471, 73.1215, 0, 0, 0, 0, 0, 0, 0, 0, 0, 18.0386, 22.5969, 22.9338, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5.65763, 23.3912],
  ],
  afloat: [
    [3678320, 3161050, 3539420, 1941980],
    [3680090, 3162520, 3540960, 1942790],
    [3681840, 3163990, 3542490, 1943600],
    [3683580, 3165450, 3544010, 1944400],
    [3685320, 3166910, 3545520, 1945200],
    [3687050, 3168360, 3547030, 1945990],
    [3688760, 3169800, 3548520, 1946780],
    [3690470, 3171230, 3550010, 1947560],
    [3692160, 3172650, 3551490, 1948340],
    [3693850, 3174060, 3552950, 1949120],
    [3695520, 3175460, 3554410, 1949880],
    [3697170, 3176850, 3555850, 1950640],
    [3698820, 3178230, 3557290, 1951400],
    [3700450, 3179590, 3558710, 1952150],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
  ],
};
